/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
/* eslint-enable no-console */
const currentSeason = document.querySelector('.carousel-3d').getAttribute('data-current-season');
const idAndLogos = document.querySelector('.carousel-3d').getAttribute('data-logo-ids');
const jsonUrl = 'https://dz8zbd8amw7pd.cloudfront.net/KCL/feeds/Comp/' + currentSeason + '/pointstable.json'; // Change to your JSON URL
const topTitleWrapper = document.querySelector('.vertical_carousel_swiper_wrap');
import { __ } from '@wordpress/i18n';

function getTeamLogo(teamId) {
    const logos = JSON.parse(idAndLogos);
    const team = logos.find(item => item.id == teamId);
    if (team) {
        return team.logo;
    } else {
        return 'No Logo Found'; // Fallback if no logo is found
    }
}

function renderVerticalCarousel(data) {
    // Render each team as a slide
    topTitleWrapper.insertAdjacentHTML('afterbegin', data.map((team, idx) => `
            <div class="vertical_carousel_score_logo_wrap swiper-slide" data-team-position="${idx + 1}">
                <div class="vertical_carousel_score_logo_wrap-inner">
                <div class="vertical_carousel_logo">
                    <img src="${getTeamLogo(team.TeamID)}" alt="` + __('Team Logo', 'kcl-blocks') + `" />
                </div>
                <div class="vertical_carousel_score_table">
                    <div class="vertical_carousel_score">
                        <div class="vertical_carousel_score_group">
                            <h5>` + __('MAT', 'kcl-blocks') + `</h5>
                            <h4>${team.M || ''}</h4>
                        </div>
                        <div class="vertical_carousel_score_group">
                            <h5>` + __('WON', 'kcl-blocks') + `</h5>
                            <h4>${team.W || ''}</h4>
                        </div>
                        <div class="vertical_carousel_score_group">
                            <h5>` + __('LOST', 'kcl-blocks') + `</h5>
                            <h4>${team.L || ''}</h4>
                        </div>
                        <div class="vertical_carousel_score_group">
                            <h5>` + __('NR', 'kcl-blocks') + `</h5>
                           <h4>${team['N/R'] ?? team.NoResult ?? ''}</h4>
                        </div>
                        <div class="vertical_carousel_score_group">
                            <h5>` + __('NRR', 'kcl-blocks') + `</h5>
                             <h4>${team.NRR ?? ''}</h4>
                        </div>
                        <div class="vertical_carousel_score_group">
                            <h5>` + __('PTS', 'kcl-blocks') + `</h5>
                            <h4>${team.Pts ?? ''}</h4>
                        </div>
                    </div>
                </div>
                </div>
            </div>
    `).join(''));

    // Insert after the HTML: Example - add a message or another element
    const afterHtml = document.createElement('div');
    afterHtml.className = 'vertical_carousel_after_html';
}

async function fetchAndRenderVerticalCarousel() {
    try {
        const response = await fetch(jsonUrl, { cache: "no-store" });
        const data = await response.json();
        // If your JSON is an object with a property, adjust here:
        // e.g. renderVerticalCarousel(data.teams);
        renderVerticalCarousel(data.PointsTable);
        initSlick();
    } catch (e) {
        topTitleWrapper.innerHTML = '<p>Error loading data</p>';
        // Optionally, log the error for debugging
        console.error('Failed to fetch or render vertical carousel:', e);
    }
}

// Initial fetch
fetchAndRenderVerticalCarousel();

let $ = jQuery;

function getSlickDirection() {
    // Check the window width and return 'horizontal' or 'vertical'
    // The condition is less than 767px for horizontal, as per your request
    return $(window).width() < 767; // true for horizontal, false for vertical
}

function initSlick() {
    const selector = '.vertical_carousel_swiper_wrap';
    const isHorizontal = getSlickDirection();

    // Destroy the slider if it already exists to re-initialize it correctly
    if ($(selector).hasClass('slick-initialized')) {
        $(selector).slick('unslick');
    }

    // Initialize the Slick slider with responsive options
    $(selector).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        // pauseOnHover: false,
        // pauseOnFocus: false,
        dots: true,
        nav: false,
        arrows: false,
        // Dynamically set the vertical parameter based on screen width
        vertical: !isHorizontal
    });

    // Re-attach the event listener after re-initialization
    $(selector).on('afterChange', function (event, slick, currentSlide) {
        // Update the counter
        // You will need to implement this function yourself if you want to use it
        updateSlideCounter(currentSlide + 1);
    });
}

// Re-initialize the slider on window resize to switch direction
$(window).on('resize', function () {
    // A simple debounce to prevent the function from firing too often
    clearTimeout(window.resizedFinished);
    window.resizedFinished = setTimeout(function () {
        initSlick();
    }, 250);
});

function updateSlideCounter(index) {
    $('#vertical_carousel_count p').text(index);
}